module.exports = __webpack_public_path__ + "img/en.b6a8ab7b.svg";